import Log from '@lib/Log'
import { useDesktop } from './use-desktop'
import {
  DESKTOP_TARGET,
  MOBILE_TARGET,
  TargetType,
} from './constants'

type Props = {
  mobileUrl: string
  mobileWidth: number
  mobileHeight: number
  mobileFallbackUrl: string
  desktopUrl: string
  desktopWidth: number
  desktopHeight: number
  desktopFallbackUrl: string
  video: HTMLVideoElement | null
}

type ResponseProps = {
  video: HTMLVideoElement
  source: HTMLSourceElement
  targetType: TargetType
} | undefined

export const attachVideo = ({
  desktopFallbackUrl,
  desktopHeight,
  desktopUrl,
  desktopWidth,
  mobileFallbackUrl,
  mobileHeight,
  mobileUrl,
  mobileWidth,
  video,
}: Props): ResponseProps => {
  if (!video) return

  video.autoplay = true
  video.muted = true
  video.loop = true
  video.setAttribute('playsinline', '')
  video.setAttribute('webkit-playsinline', '')

  const source: HTMLSourceElement = document.createElement('source')
  source.setAttribute('type', 'video/mp4')

  let targetType: TargetType = MOBILE_TARGET
  let width = mobileWidth
  let height = mobileHeight
  let poster = mobileFallbackUrl
  let src = mobileUrl

  if (useDesktop()) {
    targetType = DESKTOP_TARGET
    width = desktopWidth
    height = desktopHeight
    poster = desktopFallbackUrl
    src = desktopUrl
  }

  video.width = width
  video.height = height
  video.poster = poster
  source.setAttribute('src', src)

  Log.info(`[FeatureVideo] attaching ${targetType} video`)

  video.appendChild(source)

  return {
    video,
    targetType,
    source,
  }
}
